<template>
  <div class="mod-config">
    <div style="border-radius: 30px">
      <el-form :inline="true" size="mini" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-row>
          <el-form-item label="供应商代码" prop="venderCode">
            <el-input size="mini" v-model="venderCode" style="width: 150px " placeholder="供应商代码" clearable @blur="getDataList"></el-input>
          </el-form-item>
          <el-form-item label="供应商名称" prop="venderName">
            <el-input size="mini" v-model="venderName" style="width: 150px " placeholder="供应商名称" clearable @blur="getDataList"></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="applyStatus">
            <el-select v-model="applyStatus" clearable placeholder="请选择" @change="getDataList">
              <el-option v-for="item in options1" :key="item.value" :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" @click="queryHandle()" icon="el-icon-search" style="margin-left:20px">查询
            </el-button>
            <!-- <el-button type="primary" size="small" @click="methodFrozen()" style="margin-left:20px">冻结</el-button>
            <el-button type="primary" size="small" @click="methodThaw()" style="margin-left:20px">解冻</el-button> -->
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <div v-loading="dataListLoading">
      <el-table :data="dataList" size="mini" :row-class-name="rowClassName"
                :height="style.gridStyle.height" @selection-change="selectionChangeHandle"
                border :header-cell-style="{background:'#f5f5f5'}">
        <!-- <el-table-column align="center" v-model="something" type="selection" width="55">
        </el-table-column> -->
        <el-table-column header-align="center" label="序号" align="center" width="55">
          <template slot-scope="scope">
            {{ scope.row.rowid }}
          </template>
        </el-table-column>
        <el-table-column prop="applyformNum" header-align="center" align="right" width="120" label="审批单号">
          <template slot-scope="scope">
            {{ scope.row.applyformNum }}
          </template>
        </el-table-column>
        <el-table-column prop="venderCode" header-align="center" align="left" label="供应商代码" min-width="130">
          <template slot-scope="scope">
            {{ scope.row.venderCode }}
          </template>
        </el-table-column>
        <el-table-column prop="venderName" header-align="center" align="left" label="供应商名称" min-width="200">
          <template slot-scope="scope">
            <!-- <el-button type="text" @click="venderUserDetail(scope.row)"> {{ scope.row.venderName }}</el-button> -->
            <el-button type="text" @click="handleUpdate(scope.row)"> {{ scope.row.venderName }}</el-button>
          </template>
        </el-table-column>

        <el-table-column prop="applyStatus" header-align="center" align="center" width="120" label="状态">
          <template slot-scope="scope">
            <span style="color:#67C23A" v-for="(item, index) in scope.row.applyStatus.split(',')" :key="index" size="mini" type="success">{{item}}<br></span>
          </template>
        </el-table-column>
        <el-table-column
            prop="pic"
            header-align="center"
            align="center"
            width="120"
            label="当前流程图示">
          <template slot-scope="scope">
            <el-link :disabled="scope.row.applyStatus === '流程结束'" type="primary" style="font-size: 12px;" @click="viewDiagram(scope.row.workflowId, scope.row)"><i class="el-icon-view" style="margin-right: 5px;"></i>查看</el-link>
          </template>
        </el-table-column>

        <el-table-column
            prop="pic"
            header-align="center"
            align="center"
            width="120"
            label="评审附件">
          <template slot-scope="scope">
            <el-link type="primary" style="font-size: 12px;" @click="viewThawFile(scope.row)"><i class="el-icon-view" style="margin-right: 5px;"></i>查看</el-link>
          </template>
        </el-table-column>

        <el-table-column prop="createdName" header-align="center" align="left" width="120" label="申请人">
          <template slot-scope="scope">
            {{ scope.row.createdName }}
          </template>
        </el-table-column>
        <el-table-column prop="remark" header-align="center" align="left" width="200" label="申请原因">
          <template slot-scope="scope">
            {{ scope.row.remark }}
          </template>
        </el-table-column>
        <el-table-column prop="createTimeStr" header-align="center" align="right" width="200" label="申请日期" >
          <template slot-scope="scope">
            {{ scope.row.createTimeStr }}
          </template>
        </el-table-column>

        <el-table-column prop="disReason" header-align="center" align="center" label="审批历史">
          <template slot-scope="scope">
            <el-button @click="doHistory(scope.row)">查看</el-button>
          </template>
        </el-table-column>

        <el-table-column fixed="right" header-align="center" align="center" label="操作" min-width="170px">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.taskActions" :key="index">
              <el-button v-if="item.flowRuleType===null" type="text" size="small" @click="adoptHandle(scope.row.id, item.taskId, item.flowRuleType, item.normalValue)" icon="el-icon-circle-check">重新提交</el-button>
              <el-button v-if="item.flowRuleType!=null" type="text" size="small" @click="adoptHandle(scope.row.id, item.taskId, item.flowRuleType, item.normalValue)" icon="el-icon-circle-check">通过</el-button>
              <el-button v-if="item.flowRuleType!=null" type="text" size="small" @click="rejectHandle(scope.row.id, item.taskId, item.flowRuleType, item.reverseValue)" icon="el-icon-circle-close" style="color:#F56C6C">驳回</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
                     :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
                     layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>

    <el-dialog
        :visible.sync="showViewer"
        width="80%"
        title="流程图">
      <el-image :src="diagramUrl" style="margin-bottom: 120px;">
      </el-image>
    </el-dialog>

    <el-dialog :visible.sync="showWorkflowDialog" width="70%" title="审批进度" :close-on-click-modal="false">
      <div class="workflow-container">
        <div class="workflow-steps">
          <!-- 节点 1: 提交供应商退出优先库申请 -->
          <div class="step" :class="getStepClass(1, currentWorkflowData)">
            <div class="step-circle">1</div>
            <div class="step-label">提交供应商退出优先库申请</div>
            <div class="step-status">{{ getStepStatusText(1, currentWorkflowData) }}</div>
          </div>

          <!-- 连线 1→2 -->
          <div class="step-line" :class="getLineClass(1, 2, currentWorkflowData)"></div>

          <!-- 节点 2: 采购工程师审批 -->
          <div class="step" :class="getStepClass(2, currentWorkflowData)">
            <div class="step-circle">2</div>
            <div class="step-label">采购工程师审批</div>
            <div class="step-status">{{ getStepStatusText(2, currentWorkflowData) }}</div>
          </div>

          <!-- 连线 2→3 -->
          <div class="step-line" :class="getLineClass(2, 3, currentWorkflowData)"></div>

          <!-- 节点 3: 采购科长审批 -->
          <div class="step" :class="getStepClass(3, currentWorkflowData)">
            <div class="step-circle">3</div>
            <div class="step-label">采购科长审批</div>
            <div class="step-status">{{ getStepStatusText(3, currentWorkflowData) }}</div>
          </div>

          <!-- 连线 3→4 -->
          <div class="step-line" :class="getLineClass(3, 4, currentWorkflowData)"></div>

          <!-- 节点 4: 采购部长审批 -->
          <div class="step" :class="getStepClass(4, currentWorkflowData)">
            <div class="step-circle">4</div>
            <div class="step-label">采购部长审批</div>
            <div class="step-status">{{ getStepStatusText(4, currentWorkflowData) }}</div>
          </div>

          <!-- 连线 4→5 -->
          <div class="step-line" :class="getLineClass(4, 5, currentWorkflowData)"></div>

          <!-- 节点 5: 采购总监审批 -->
          <div class="step" :class="getStepClass(5, currentWorkflowData)">
            <div class="step-circle">5</div>
            <div class="step-label">采购总监审批</div>
            <div class="step-status">{{ getStepStatusText(5, currentWorkflowData) }}</div>
          </div>

          <!-- 连线 5→6 -->
          <div class="step-line" :class="getLineClass(5, 6, currentWorkflowData)"></div>

          <!-- 节点 6: 流程结束 -->
          <div class="step" :class="getStepClass(6, currentWorkflowData)">
            <div class="step-circle">6</div>
            <div class="step-label">流程结束</div>
            <div class="step-status">{{ getStepStatusText(6, currentWorkflowData) }}</div>
          </div>
        </div>

        <!-- 当前状态说明 -->
        <div class="current-status">
          <h4>当前状态：{{ getCurrentStatusText(currentWorkflowData) }}</h4>
          <p>{{ getCurrentStatusDesc(currentWorkflowData) }}</p>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="审批" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="dataRule">
        <el-form-item label="驳回原因:" :label-width="formLabelWidth" prop="remarks">
          <el-input type="textarea" v-model="form.remarks" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="rejectHandle2" size="mini">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog class="abow_dialog " width="90%" top=0 :title="this.activeName" :visible.sync="gpsdialog"
               style="min-height:100px" @close="closegps" :close-on-click-modal="false">
      <div style="min-hight:100px">
        <div style="margin-top:5px">
          <el-tabs class="supplier-info-tabs" v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane name="企业概况" :key="'first'">
              <span slot="label"><span style="color: red">*</span> 企业概况</span>
              <enterprise-profile ref="enterpriseProfile" :superId="this.supplierId"></enterprise-profile>
            </el-tab-pane>
            <el-tab-pane name="主要联系人员" :key="'second'">
              <span slot="label"><span style="color: red">*</span> 主要联系人员</span>
              <main-contacts ref="mainContacts" :superId="this.supplierId"></main-contacts>
            </el-tab-pane>
            <el-tab-pane label="企业资源情况" name="企业资源情况">
              <span slot="label"><span style="color: red">*</span> 企业资源情况</span>
              <resource-info ref="resourceInfo" :superId="this.supplierId"></resource-info>
            </el-tab-pane>
            <el-tab-pane  label="工厂及地址" name="工厂及地址">
              <span slot="label"><span style="color: red">*</span> 工厂及地址</span>
              <factory-info ref="factoryInfo" :superId="this.supplierId"></factory-info>
            </el-tab-pane>
            <el-tab-pane  label="企业经营状况" name="企业经营状况">
              <span slot="label"><span style="color: red">*</span> 企业经营状况</span>
              <business-info ref="businessInfo" :superId="this.supplierId"></business-info>
            </el-tab-pane>
            <el-tab-pane  label="主要产品目录" name="主要产品目录">
              <span slot="label"><span style="color: red">*</span> 主要产品目录</span>
              <product-info ref="productInfo" :superId="this.supplierId"></product-info>
            </el-tab-pane>
            <el-tab-pane  label="附件上传" name="附件上传">
              <span slot="label"><span style="color: red">*</span> 附件上传</span>
              <attachment-upload ref="attachmentUpload" :superId="this.supplierId"></attachment-upload>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </el-dialog>

    <el-drawer title="审批履历" :visible.sync="drawer" :with-header="true">
      <div v-for="str in historyList" :key="str">
        <el-descriptions :title="str.executeTime">
          <el-descriptions-item label="审批类型">{{str.taskName}}</el-descriptions-item>
          <el-descriptions-item label="审批结果">{{str.executeName}}</el-descriptions-item>
        </el-descriptions>
        <el-divider></el-divider>
      </div>
    </el-drawer>

    <el-dialog
        title="提示"
        :visible.sync="fileDialogVisible"
        width="60%"
        :modal="false"
    >

      <!-- 上传下载 查看 需求文档 -->
      <FileUpDown ref="FileUpDown" :fileSubType="FILE_SUB_TYPE" :bizId="dataForm.id" :bizType="FILE_BIZ_TYPE"></FileUpDown>

      <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="fileDialogVisible = false">关 闭</el-button>
          </span>
    </el-dialog>

  </div>
</template>
<script>
import {firstApprove,listInExitApplyPage} from '@/controller/supplier'
import { listAllStatus,getProcessDiagramCurrent,listCommentHistory} from '@/controller/workflow'
import FileUpDown from "@/views/common/file-up-down"

import EnterpriseProfile from '@/views/modules/supplier/common/basicInfo/enterpriseProfile'
import MainContacts from '@/views/modules/supplier/common/basicInfo/mainContacts'
import ResourceInfo from '@/views/modules/supplier/common/basicInfo/resourceInfo'
import FactoryInfo from '@/views/modules/supplier/common/basicInfo/factoryInfo'
import BusinessInfo from '@/views/modules/supplier/common/basicInfo/businessInfo'
import ProductInfo from '@/views/modules/supplier/common/basicInfo/productInfo'
import AttachmentUpload from '@/views/modules/supplier/common/basicInfo/attachmentUpload'

export default {
  name:'inExitExitIndex',
  data() {
    return {
      FILE_BIZ_TYPE:5,
      FILE_SUB_TYPE:0,
      dataForm: {
        id:'',
        key: ''
      },
      applyStatus: '',
      showViewer: false,
      fileDialogVisible:false,
      diagramUrl: '',
      activeName: '',
      gpsdialog: false,
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      dialogFormVisible: false,
      formLabelWidth: '120px',
      supplierId:'',

      venderName: '',


      something: '',
      style: {
        leftStyle: {
          height: (parseInt(document.documentElement['clientHeight']) - 325) + "px",
          overflow: "auto"
        },
        rightStyle: {
          height: (parseInt(document.documentElement['clientHeight']) - 205) + "px"
        },
        gridStyle: {
          height: (parseInt(document.documentElement['clientHeight']) - 215) + "px"
        }
      },

      dataRule: {
        remarks: [
          { required: true, message: '请填写驳回原因', trigger: 'blur' }
        ],
      },

      venderCode : '',

      // 通过或驳回表单
      form: {
        remarks: '',
        id: '',
        taskId:'',
        flowType:'',
        val:''
      },

      // 审批历史
      drawer: false,
      // 审批列表
      historyList:[],
      // 新增：工作流相关
      showWorkflowDialog: false,  // 控制工作流对话框显示
      currentWorkflowData: null, // 当前行数据
      statusPriority: {
        '提交供应商退出优先库申请': 1,
        '采购工程师审批': 2,
        '采购科长审批': 3,
        '采购部长审批': 4,
        '采购总监审批': 5,
        '流程结束': 6
      }
    }
  },

  components: {
    FileUpDown,
    EnterpriseProfile,
    ResourceInfo,
    MainContacts,
    FactoryInfo,
    BusinessInfo,
    ProductInfo,
    AttachmentUpload
  },

  activated() {
    if (this.$route.query && this.$route.query.state && this.$route.query.state.length > 0) {
      this.applyStatus = this.$route.query.state
    }
    this.getDataList()
    this.getAllStatus()
  },

  methods: {

    dateFormat: function (row, column) {
      var date = row[column.property]
      if (!date) {
        return ''
      }
      return moment(date).format("YYYY-MM-DD HH:mm:ss")
    },

    viewDiagram(id, row) {
      // 如果能找到对应行数据，则使用新的工作流对话框
      if (row) {
        this.currentWorkflowData = row;
        this.showWorkflowDialog = true;
      } else {
        // 否则使用原来的流程图查看功能
        getProcessDiagramCurrent({id: id}).then(data => {
          this.diagramUrl = data.body;
          this.showViewer = true;
        });
      }
    },

    getStepClass(step, rowData) {
      const status = this.getStepStatus(step, rowData);
      return {
        'step-completed': status === 'completed',
        'step-current': status === 'current',
        'step-pending': status === 'pending'
      };
    },

    // 获取连线样式类
    getLineClass(fromStep, toStep, rowData) {
      const fromStatus = this.getStepStatus(fromStep, rowData);
      const toStatus = this.getStepStatus(toStep, rowData);

      // 如果前一个节点已完成，连线显示为完成状态
      if (fromStatus === 'completed' && (toStatus === 'current' || toStatus === 'completed')) {
        return 'line-completed';
      }
      // 如果前一个节点是进行中，且后一个节点是当前节点
      else if (fromStatus === 'current' && toStatus === 'current') {
        return 'line-active';
      }
      return 'line-pending';
    },

    // 获取步骤状态
    getStepStatus(step, rowData) {
      const status = rowData ? rowData.applyStatus : '';
      const priority = this.statusPriority[status] || 0;

      // 定义各状态的预期流程
      const statusSequence = [
        { step: 1, name: '提交供应商退出优先库申请', requiredStatus: '提交供应商退出优先库申请' },
        { step: 2, name: '采购工程师审批', requiredStatus: '采购工程师审批' },
        { step: 3, name: '采购科长审批', requiredStatus: '采购科长审批' },
        { step: 4, name: '采购部长审批', requiredStatus: '采购部长审批' },
        { step: 5, name: '采购总监审批', requiredStatus: '采购总监审批' },
        { step: 6, name: '流程结束', requiredStatus: '流程结束' }
      ];

      // 找到当前步骤对应的配置
      const currentStepConfig = statusSequence.find(s => s.step === step);
      if (!currentStepConfig) return 'pending';

      // 如果当前状态等于该步骤的状态，则为进行中
      if (status === currentStepConfig.requiredStatus) {
        return 'current';
      }

      // 如果当前状态优先级高于该步骤的状态，则为已完成
      if (priority > this.statusPriority[currentStepConfig.requiredStatus]) {
        return 'completed';
      }

      // 否则为待处理
      return 'pending';
    },

    // 获取步骤状态文本
    getStepStatusText(step, rowData) {
      const status = this.getStepStatus(step, rowData);
      switch (status) {
        case 'completed':
          return '✓ 已完成';
        case 'current':
          return '▶ 进行中';
        case 'pending':
          return '○ 待处理';
        default:
          return '';
      }
    },

    // 获取当前状态文本
    getCurrentStatusText(rowData) {
      const statusMap = {
        '提交供应商退出优先库申请': '提交供应商退出优先库申请',
        '采购工程师审批': '等待采购工程师审批',
        '采购科长审批': '等待采购科长审批',
        '采购部长审批': '等待采购部长审批',
        '采购总监审批': '等待采购总监审批',
        '流程结束': '流程已完成'
      };

      if (rowData && rowData.applyStatus) {
        return statusMap[rowData.applyStatus] || rowData.applyStatus;
      }

      return '';
    },

    // 获取当前状态描述
    getCurrentStatusDesc(rowData) {
      const descMap = {
        '提交供应商退出优先库申请': '正在提交供应商退出优先库申请',
        '采购工程师审批': '采购工程师正在审核退出申请',
        '采购科长审批': '采购科长正在审核退出申请',
        '采购部长审批': '采购部长正在审核退出申请',
        '采购总监审批': '采购总监正在审核退出申请',
        '流程结束': '所有审批环节已完成，供应商退出优先库申请通过'
      };

      if (rowData && rowData.applyStatus) {
        return descMap[rowData.applyStatus] || '暂无状态描述';
      }

      return '暂无状态描述';
    },

    // 显示文件列表
    viewThawFile(row){

      if(row.applyformType === 12){
        this.FILE_SUB_TYPE = 5
      }
      if(row.applyformType === 13){
        this.FILE_SUB_TYPE = 6
      }
      this.dataForm.id = row.targetId
      this.fileView()
    },

    getAllStatus(){
      listAllStatus({
        'processDefKey': 'SNP'
      }).then(data => {
        if (data && data.code === '00') {
          this.options1 = data.body.map(str => {
            return {'value': str, 'label': str}
          })
        }
      })
    },

    // 查询按钮
    queryHandle() {
      this.pageIndex = 1
      this.getDataList()
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      listInExitApplyPage({
        'pageNo': this.pageIndex,
        'pageSize': this.pageSize,
        'venderCode': this.venderCode,
        'venderName' : this.venderName,
        'applyStatus': this.applyStatus,
        'applyformType' : 13,
      }).then(data => {
        if (data && data.code === '00') {
          this.dataList = data.body.records
          this.totalPage = data.body.total
          this.starttime = data.starttime
          this.endtime = data.endtime
          this.endtime = data.endtime
        } else {
          this.dataList = []
          this.totalPage = 0
        }
      }).catch((e) => {
        console.log(e)
      }).finally(() => {
        this.dataListLoading = false
      })
    },

    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    //多选
    selectionChangeHandle(val) {
      this.dataListSelections = val
    },
    //单选
    radioChange(row) {
      this.dataListSelections = row;
    },


    // 驳回
    rejectHandle(id, taskId, flowType, val) {
      this.form.remarks = ''
      this.form.id = id,
          this.form.taskId = taskId,
          this.form.flowType = flowType,
          this.form.val = val,

          this.dialogFormVisible = true
    },

    // 驳回2
    rejectHandle2() {
      if(!this.form.remarks){
        this.$message({message: '请填写驳回原因',type: 'error'})
        return
      }

      this.$confirm(`确定进行通过操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.dialogFormVisible = false
        let params = {
          'id': this.form.id,
          'unQuoteReason': this.form.remarks,
          'taskId': this.form.taskId,
          'paramKey': this.form.flowType,
          'paramVal': this.form.val,
        }

        firstApprove(params
        ).then(data => {
          if (data && data.code === '00') {
            this.getDataList()
            this.$message({
              message: '审批成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.visible = false
                this.$emit('refreshDataList')
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },

    // 通过
    adoptHandle(id, taskId, flowType, val) {
      this.$confirm(`确定进行通过操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          'id': id,
          'taskId': taskId,
          'paramKey': flowType,
          'paramVal': val
        }

        firstApprove(params
        ).then(data => {
          if (data && data.code === '00') {
            this.getDataList()
            this.$message({
              message: '审批成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.visible = false
                this.$emit('refreshDataList')
                this.dialogFormVisible = false
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },

    //已完成未完成筛选
    handleCheckAllChange() {
      this.pageIndex = 1
      this.getDataList()
    },
    rowClassName({
                   row,
                   rowIndex
                 }) {
      //把每一行的索引放进row.id
      row.rowid = rowIndex + 1 + (this.pageSize * (this.pageIndex - 1));
    },

    //关闭弹框的事件
    closeDialog() {
      this.getDataList()
    },
    filterHandler(value, row, column) {
      const property = column['property'];
      return row[property] === value;
    },



    handleClick: function () {
      if (this.activeName === '企业概况') {
        this.$refs.enterpriseProfile.getDataList(this.superId)
      }
      if (this.activeName === '主要联系人员') {
        this.$refs.mainContacts.getDataList(this.superId)
      }
      if (this.activeName === '企业资源情况') {
        this.$refs.resourceInfo.getDataList(this.superId)
      }
      if (this.activeName === '工厂及地址') {
        this.$refs.factoryInfo.getDataList(this.superId)
      }
      if (this.activeName === '企业经营状况') {
        this.$refs.businessInfo.getDataList(this.superId)
      }
      if (this.activeName === '体系认证情况') {
        this.$refs.certificationInfo.getDataList(this.superId)
      }
      if (this.activeName === '主要产品目录') {
        this.$refs.productInfo.getDataList(this.superId)
      }
      if (this.activeName === '主要设备清单') {
        this.$refs.equipmentList.getDataList(this.superId)
      }
      if (this.activeName === '附件上传') {
        this.$refs.attachmentUpload.getDataList(this.superId)
      }
    },

    handleUpdate(row) {
      this.gisIdKey = row.targetId
      this.gpsPid = row.pid
      this.activeName = '企业概况'
      this.gpsdialog = true
      this.targetId = row.targetId
      this.applyformId = row.applyformId
      this.statusbotton = row.applyStatus
      this.nextapplyformId = row.nextapplyformId
      this.approveLevel = row.approveLevel
      this.updatedBy = row.updatedBy
      this.supplierId = row.supplierInviteId
      this.superId = row.venderInviteFid
      this.$nextTick(() => {
        this.$refs.enterpriseProfile.getDataList(row.venderInviteFid)
      })
    },

    closegps() {
      this.getDataList()
    },

    // 审批历史
    doHistory(row){
      this.historyList = []
      listCommentHistory({'workflowId' : row.workflowId}).then(data => {
        if (data && data.code === '00') {
          this.historyList = data.body
        } else {
          this.$message.error(data.msg)
        }
      })
      this.drawer = true
    },

    // 文件列表
    fileView(){
      this.fileDialogVisible = true
      this.$nextTick(()=>{
        this.$refs.FileUpDown.init(this.dataForm.id, this.FILE_BIZ_TYPE, this.FILE_SUB_TYPE)
      })
    },

  }
}
</script>

<style scoped>
.abow_dialog {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.abow_dialog /deep/ .el-dialog {
  margin: 0 auto !important;
  height: 90%;
  display: flex;
  flex-direction: column;
}
.abow_dialog /deep/ .el-dialog .el-dialog__body {
  flex: 1;
  overflow-y: auto;
}
/* 工作流样式 */
.workflow-container {
  padding: 20px;
}

.workflow-steps {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  margin: 40px 0;
  padding: 0 20px;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
  min-width: 100px;
}

.step-circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #e4e7ed;
  color: #606266;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 16px;
  border: 3px solid #e4e7ed;
  transition: all 0.3s ease;
  margin-bottom: 10px;
}

.step-label {
  font-size: 12px;
  color: #303133;
  text-align: center;
  font-weight: 500;
  margin-bottom: 5px;
  width: 100px;
  word-wrap: break-word;
}

.step-status {
  font-size: 12px;
  color: #909399;
  text-align: center;
}

/* 步骤状态样式 */
.step-completed .step-circle {
  background: #67c23a;
  color: white;
  border-color: #67c23a;
}

.step-current .step-circle {
  background: #409eff;
  color: white;
  border-color: #409eff;
  animation: pulse 2s infinite;
}

.step-pending .step-circle {
  background: #e4e7ed;
  color: #606266;
  border-color: #e4e7ed;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(64, 158, 255, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(64, 158, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(64, 158, 255, 0);
  }
}

/* 连线样式 */
.step-line {
  flex: 1;
  height: 4px;
  background: #e4e7ed;
  margin: 0 10px;
  position: relative;
  top: -22px;
  transition: all 0.3s ease;
}

.line-completed {
  background: #67c23a;
}

.line-active {
  background: linear-gradient(90deg, #67c23a 0%, #409eff 100%);
}

.line-pending {
  background: #e4e7ed;
}

/* 当前状态说明 */
.current-status {
  margin-top: 40px;
  padding: 20px;
  background: #f5f7fa;
  border-radius: 8px;
  border-left: 4px solid #409eff;
}

.current-status h4 {
  margin: 0 0 10px 0;
  color: #303133;
  font-size: 16px;
}

.current-status p {
  margin: 0;
  color: #606266;
  line-height: 1.6;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .workflow-steps {
    flex-direction: column;
    gap: 30px;
  }

  .step-line {
    width: 4px;
    height: 40px;
    margin: 10px 0;
    top: 0;
  }
}
</style>
